'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import Modal from './Modal';
import Link from 'next/link';
import { SocialMediaIcon } from './SocialMediaIcon';
import { Buttton } from '../common';
import styles from '@/styles/components/URLShareDialog.module.scss';
export const URLShareDialog = t0 => {
  const $ = _c(58);
  const {
    text,
    url,
    via: t1,
    dictionary: t2
  } = t0;
  const via = t1 === undefined ? "" : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? {
      label: "Share",
      linkToShare: "Link to Share",
      copied: "Copied"
    } : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const dictionary = t3;
  const [isTextCopied, setIsTextCopied] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const encodedText = encodeURIComponent(text);
  const encodedUrl = encodeURIComponent(url);
  let t4;
  if ($[2] !== url) {
    t4 = () => {
      navigator.clipboard.writeText(url + "?source=share-link");
      setIsTextCopied(true);
      setTimeout(() => setIsTextCopied(false), 1000);
    };
    $[2] = url;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleCopyLinkClick = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = event => {
      if ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key === "S") {
        event.preventDefault();
        setIsModalVisible(true);
      } else {
        setIsModalVisible(false);
      }
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const handleKeyDown = t5;
  let t6;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      document.addEventListener("keydown", handleKeyDown);
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    };
    t7 = [];
    $[5] = t6;
    $[6] = t7;
  } else {
    t6 = $[5];
    t7 = $[6];
  }
  useEffect(t6, t7);
  const t8 = `https://x.com/intent/post?text=${encodedText}&url=${encodedUrl}?source=share-x${via ? `&via=${encodeURIComponent(via)}` : ""}`;
  let t9;
  if ($[7] !== t8) {
    t9 = {
      name: "X",
      url: t8,
      icon: "x"
    };
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const t10 = `https://t.me/share/url?text=${encodedText}&url=${encodedUrl}?source=share-telegram`;
  let t11;
  if ($[9] !== t10) {
    t11 = {
      name: "Telegram",
      url: t10,
      icon: "telegram"
    };
    $[9] = t10;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  const t12 = `https://api.whatsapp.com/send?text=${encodedText} ${encodedUrl}?source=share-wa`;
  let t13;
  if ($[11] !== t12) {
    t13 = {
      name: "WhatsApp",
      url: t12,
      icon: "whatsapp"
    };
    $[11] = t12;
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  let t14;
  if ($[13] !== t11 || $[14] !== t13 || $[15] !== t9) {
    t14 = [t9, t11, t13];
    $[13] = t11;
    $[14] = t13;
    $[15] = t9;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  const socialPlatforms = t14;
  let t15;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => setIsModalVisible(true);
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <svg height="16" strokeLinejoin="round" viewBox="0 0 16 16" width="16" style={{
      color: "currentcolor"
    }}><path fillRule="evenodd" clipRule="evenodd" d="M15 11.25V10.5H13.5V11.25V12.75C13.5 13.1642 13.1642 13.5 12.75 13.5H3.25C2.83579 13.5 2.5 13.1642 2.5 12.75L2.5 3.25C2.5 2.83579 2.83579 2.5 3.25 2.5H5.75H6.5V1H5.75H3.25C2.00736 1 1 2.00736 1 3.25V12.75C1 13.9926 2.00736 15 3.25 15H12.75C13.9926 15 15 13.9926 15 12.75V11.25ZM15 5.5L10.5 1V4C7.46243 4 5 6.46243 5 9.5V10L5.05855 9.91218C6.27146 8.09281 8.31339 7 10.5 7V10L15 5.5Z" fill="currentColor" /></svg>;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  const t17 = dictionary?.label;
  let t18;
  if ($[19] !== t17) {
    t18 = <Buttton className={styles.shareButton} onClick={t15}>{t16}<span>{t17}</span></Buttton>;
    $[19] = t17;
    $[20] = t18;
  } else {
    t18 = $[20];
  }
  let t19;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => setIsModalVisible(false);
    $[21] = t19;
  } else {
    t19 = $[21];
  }
  const t20 = dictionary?.label;
  let t21;
  if ($[22] !== t20) {
    t21 = <h3>{t20}</h3>;
    $[22] = t20;
    $[23] = t21;
  } else {
    t21 = $[23];
  }
  let t22;
  if ($[24] !== socialPlatforms) {
    t22 = <ul className={styles.platformList}>{socialPlatforms.map(_temp)}</ul>;
    $[24] = socialPlatforms;
    $[25] = t22;
  } else {
    t22 = $[25];
  }
  let t23;
  if ($[26] !== t21 || $[27] !== t22) {
    t23 = <section>{t21}{t22}</section>;
    $[26] = t21;
    $[27] = t22;
    $[28] = t23;
  } else {
    t23 = $[28];
  }
  const t24 = dictionary?.linkToShare;
  let t25;
  if ($[29] !== t24) {
    t25 = <h4>{t24}</h4>;
    $[29] = t24;
    $[30] = t25;
  } else {
    t25 = $[30];
  }
  let t26;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = {
      display: "flex"
    };
    $[31] = t26;
  } else {
    t26 = $[31];
  }
  let t27;
  if ($[32] !== url) {
    t27 = <span>{url}</span>;
    $[32] = url;
    $[33] = t27;
  } else {
    t27 = $[33];
  }
  let t28;
  if ($[34] !== isTextCopied) {
    t28 = isTextCopied ? <svg height="16" strokeLinejoin="round" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" clipRule="evenodd" d="M15.5607 3.99999L15.0303 4.53032L6.23744 13.3232C5.55403 14.0066 4.44599 14.0066 3.76257 13.3232L4.2929 12.7929L3.76257 13.3232L0.969676 10.5303L0.439346 9.99999L1.50001 8.93933L2.03034 9.46966L4.82323 12.2626C4.92086 12.3602 5.07915 12.3602 5.17678 12.2626L13.9697 3.46966L14.5 2.93933L15.5607 3.99999Z" fill="green" /></svg> : <svg height="16" strokeLinejoin="round" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" clipRule="evenodd" d="M2.75 0.5C1.7835 0.5 1 1.2835 1 2.25V9.75C1 10.7165 1.7835 11.5 2.75 11.5H3.75H4.5V10H3.75H2.75C2.61193 10 2.5 9.88807 2.5 9.75V2.25C2.5 2.11193 2.61193 2 2.75 2H8.25C8.38807 2 8.5 2.11193 8.5 2.25V3H10V2.25C10 1.2835 9.2165 0.5 8.25 0.5H2.75ZM7.75 4.5C6.7835 4.5 6 5.2835 6 6.25V13.75C6 14.7165 6.7835 15.5 7.75 15.5H13.25C14.2165 15.5 15 14.7165 15 13.75V6.25C15 5.2835 14.2165 4.5 13.25 4.5H7.75ZM7.5 6.25C7.5 6.11193 7.61193 6 7.75 6H13.25C13.3881 6 13.5 6.11193 13.5 6.25V13.75C13.5 13.8881 13.3881 14 13.25 14H7.75C7.61193 14 7.5 13.8881 7.5 13.75V6.25Z" fill="currentColor" /></svg>;
    $[34] = isTextCopied;
    $[35] = t28;
  } else {
    t28 = $[35];
  }
  let t29;
  if ($[36] !== dictionary?.copied || $[37] !== isTextCopied) {
    t29 = isTextCopied && <span className={styles.copiedText}>{dictionary?.copied}</span>;
    $[36] = dictionary?.copied;
    $[37] = isTextCopied;
    $[38] = t29;
  } else {
    t29 = $[38];
  }
  let t30;
  if ($[39] !== t28 || $[40] !== t29) {
    t30 = <div className={styles.copy}>{t28}{t29}</div>;
    $[39] = t28;
    $[40] = t29;
    $[41] = t30;
  } else {
    t30 = $[41];
  }
  let t31;
  if ($[42] !== handleCopyLinkClick || $[43] !== t27 || $[44] !== t30) {
    t31 = <div style={t26}><button className={styles.shareLinkCopy} onClick={handleCopyLinkClick}>{t27}{t30}</button></div>;
    $[42] = handleCopyLinkClick;
    $[43] = t27;
    $[44] = t30;
    $[45] = t31;
  } else {
    t31 = $[45];
  }
  let t32;
  if ($[46] !== t25 || $[47] !== t31) {
    t32 = <section>{t25}{t31}</section>;
    $[46] = t25;
    $[47] = t31;
    $[48] = t32;
  } else {
    t32 = $[48];
  }
  let t33;
  if ($[49] !== t23 || $[50] !== t32) {
    t33 = <div className={styles.shareDialog}>{t23}{t32}</div>;
    $[49] = t23;
    $[50] = t32;
    $[51] = t33;
  } else {
    t33 = $[51];
  }
  let t34;
  if ($[52] !== isModalVisible || $[53] !== t33) {
    t34 = <Modal variant="responsive" isVisiable={isModalVisible} onClose={t19}>{t33}</Modal>;
    $[52] = isModalVisible;
    $[53] = t33;
    $[54] = t34;
  } else {
    t34 = $[54];
  }
  let t35;
  if ($[55] !== t18 || $[56] !== t34) {
    t35 = <div className={styles.share}>{t18}{t34}</div>;
    $[55] = t18;
    $[56] = t34;
    $[57] = t35;
  } else {
    t35 = $[57];
  }
  return t35;
};
export default URLShareDialog;
function _temp(platform) {
  return <li key={`share-${platform.name}`} className={styles.platformListItem}><SocialMediaIcon platform={platform.icon} width={48} height={48} className={styles.platformListItemIcon} /><Link href={platform.url} target="_blank" rel="noopener noreferrer" className={styles.platformListItemLink} prefetch={false}><span>{platform.name}</span></Link></li>;
}